import { toExtension } from "@/utills/files/toExtention";

const imageFormats = ["jpg", "jpeg", "png", "gif"];

export function isImage(file) {
  return imageFormats.indexOf(toExtension(file.name)) !== -1;
}
